import {
  IconBell, IconSpeakerphone, IconCalendarCheck, IconChecklist, IconBook2,
  IconCash, IconCrown, IconMessageCircle, type Icon,
} from '@tabler/icons-react';

// Backend NotificationType enum bilan bir xil tartibda (sinxron saqlansin).
export const NOTIF_TYPES = ['ANNOUNCEMENT', 'ATTENDANCE', 'GRADE', 'HOMEWORK', 'PAYMENT', 'PREMIUM', 'SUPPORT', 'SYSTEM'] as const;
export type NotifType = (typeof NOTIF_TYPES)[number];

// Har bir tur uchun rang + ikonka — Notifications sahifasi va header bell uchun yagona manba.
export const NOTIF_TYPE_META: Record<NotifType, { color: string; icon: Icon }> = {
  ANNOUNCEMENT: { color: 'grape', icon: IconSpeakerphone },
  ATTENDANCE: { color: 'blue', icon: IconCalendarCheck },
  GRADE: { color: 'red', icon: IconChecklist },
  HOMEWORK: { color: 'yellow', icon: IconBook2 },
  PAYMENT: { color: 'green', icon: IconCash },
  PREMIUM: { color: 'orange', icon: IconCrown },
  SUPPORT: { color: 'cyan', icon: IconMessageCircle },
  SYSTEM: { color: 'gray', icon: IconBell },
};
